import { CodeItemService } from './../../common/services/codeitem.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { Component, OnInit } from '@angular/core';
import { BaseCodeitemEditorComponent } from '../codeitem-base/codeitem-base.component';

@Component({
  selector: 'prg-codeitem-command',
  templateUrl: './codeitem-command.component.html',
  styleUrls: ['./codeitem-command.component.css']
})
export class CodeitemCommandComponent extends BaseCodeitemEditorComponent implements OnInit {

  constructor(
    store: Store<any>,
    router: Router,
    route: ActivatedRoute,
    codeitemService: CodeItemService) {
    super(store, router, route, codeitemService);

    store.select(s => s.advancedProgramming.device).subscribe(
      device => {
        if (device) {
          router.navigate(['../command'], { relativeTo: route });
        }
      });

  }

  ngOnInit() {
      this.codeitemService.setType(1);

  }

}



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/advanced/codeitem-command/codeitem-command.component.ts